(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clickable-image-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ClickableImageSlideshow extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-index]'));
      this.slidesRegion = this.querySelector('[data-slides]');
      this.counter = this.querySelector('[data-current-slide]');
      this.pauseButton = this.querySelector('[data-action="pause"]');
      this.playButton = this.querySelector('[data-action="play"]');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
      this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.autoplaySpeed = Number.parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.loop = this.dataset.loop === 'true';
      this.manuallyPaused = false;

      this.addEventListener('click', this.handleClick, { signal: this.abortController.signal });
      this.addEventListener('mouseenter', this.stopAutoplay, { signal: this.abortController.signal });
      this.addEventListener('mouseleave', this.resumeAutoplay, { signal: this.abortController.signal });
      this.addEventListener('focusin', this.stopAutoplay, { signal: this.abortController.signal });
      this.addEventListener('focusout', this.handleFocusOut, { signal: this.abortController.signal });
      this.addEventListener('shopify:block:select', this.handleBlockSelect, {
        signal: this.abortController.signal,
      });
      document.addEventListener('visibilitychange', this.handleVisibilityChange, {
        signal: this.abortController.signal,
      });

      this.showSlide(this.currentIndex, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.stopAutoplay();
    }

    handleClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;

      if (button.dataset.slideIndex !== undefined) {
        this.showSlide(Number.parseInt(button.dataset.slideIndex, 10));
        return;
      }

      switch (button.dataset.action) {
        case 'previous':
          this.showSlide(this.currentIndex - 1);
          break;
        case 'next':
          this.showSlide(this.currentIndex + 1);
          break;
        case 'pause':
          this.manuallyPaused = true;
          this.stopAutoplay();
          this.updateAutoplayControls();
          break;
        case 'play':
          this.manuallyPaused = false;
          this.startAutoplay();
          this.updateAutoplayControls();
          break;
      }
    };

    handleFocusOut = (event) => {
      if (!this.contains(event.relatedTarget)) this.resumeAutoplay();
    };

    handleBlockSelect = (event) => {
      if (!(event.target instanceof Element)) return;
      const slide = event.target.closest('[data-slide]');
      const index = this.slides.indexOf(slide);
      if (index < 0) return;
      this.manuallyPaused = true;
      this.stopAutoplay();
      this.updateAutoplayControls();
      this.showSlide(index, false);
    };

    handleVisibilityChange = () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.resumeAutoplay();
      }
    };

    showSlide(index, animate = true) {
      if (!this.slides.length) return;

      let nextIndex = index;
      if (this.loop) {
        nextIndex = (index + this.slides.length) % this.slides.length;
      } else {
        nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      }

      this.slides.forEach((slide, slideIndex) => {
        const isCurrent = slideIndex === nextIndex;
        slide.hidden = !isCurrent;
        slide.setAttribute('aria-hidden', String(!isCurrent));
        slide.classList.remove('is-entering');
        if (isCurrent && animate) {
          requestAnimationFrame(() => slide.classList.add('is-entering'));
        }
      });

      this.currentIndex = nextIndex;
      this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === nextIndex)));
      if (this.counter) this.counter.textContent = String(nextIndex + 1);

      const previousButton = this.querySelector('[data-action="previous"]');
      const nextButton = this.querySelector('[data-action="next"]');
      if (previousButton) previousButton.disabled = !this.loop && nextIndex === 0;
      if (nextButton) nextButton.disabled = !this.loop && nextIndex === this.slides.length - 1;
    }

    startAutoplay = () => {
      if (!this.autoplayEnabled || this.manuallyPaused || document.hidden) return;
      this.stopAutoplay();
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), this.autoplaySpeed);
      if (this.slidesRegion) this.slidesRegion.setAttribute('aria-live', 'off');
    };

    stopAutoplay = () => {
      if (this.autoplayTimer) window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = undefined;
    };

    resumeAutoplay = () => {
      if (!this.manuallyPaused) this.startAutoplay();
    };

    updateAutoplayControls() {
      if (this.pauseButton) this.pauseButton.hidden = this.manuallyPaused;
      if (this.playButton) this.playButton.hidden = !this.manuallyPaused;
      if (this.slidesRegion) this.slidesRegion.setAttribute('aria-live', this.manuallyPaused ? 'polite' : 'off');
    }
  }

  if (!customElements.get('clickable-image-slideshow')) {
    customElements.define('clickable-image-slideshow', ClickableImageSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staff-product-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-staff-search]');
    if (!root || root.dataset.ready === 'true') return;

    root.dataset.ready = 'true';
    const form = root.querySelector('[data-staff-search-form]');
    const results = root.querySelector('[data-staff-search-results]');
    const status = root.querySelector('[data-staff-search-status]');
    const grid = root.querySelector('[data-staff-grid]');
    const count = root.querySelector('[data-staff-result-count]');
    const pagination = root.querySelector('[data-staff-pagination]');
    const priceToggle = root.querySelector('[data-staff-price-toggle]');
    const bigToggle = root.querySelector('[data-staff-big-toggle]');
    const pageSize = 48;
    let products = [];
    let filteredProducts = [];
    let currentPage = 1;
    let requestController;

    const normalize = (value) => String(value || '').trim().toLocaleLowerCase();
    const splitValues = (value) =>
      String(value || '')
        .split(',')
        .map((part) => part.trim())
        .filter(Boolean);
    const splitStoneShapes = (value) =>
      splitValues(value)
        .map((shape) => shape.replace(/^and\s+/i, '').trim())
        .filter(Boolean);

    const readNumber = (value) => {
      if (String(value || '').trim() === '') return null;
      const number = Number(value);
      return Number.isFinite(number) ? number : null;
    };

    const parseProduct = (element, index) => {
      let tags = [];
      try {
        tags = JSON.parse(element.dataset.tags || '[]');
      } catch (error) {
        tags = [];
      }

      return {
        element,
        index,
        title: element.dataset.title || '',
        productType: element.dataset.productType || '',
        tags,
        metal: splitValues(element.dataset.metal),
        manufacturer: element.dataset.manufacturer || '',
        stoneShape: splitStoneShapes(element.dataset.stoneShape),
        colour: element.dataset.colour || '',
        clarity: element.dataset.clarity || '',
        diamondOrigin: element.dataset.diamondOrigin || '',
        caratWeight: readNumber(element.dataset.caratWeight),
        centreDiamondWeight: readNumber(element.dataset.centreDiamondWeight),
        gramWeights: String(element.dataset.gramWeights || '')
          .split('|')
          .map(readNumber)
          .filter((value) => value !== null),
        price: Number(element.dataset.price || 0) / 100,
        published: Number(element.dataset.published || 0),
        searchText: normalize(element.dataset.searchText),
      };
    };

    const setPreference = (key, value) => {
      try {
        localStorage.setItem(key, value ? 'true' : 'false');
      } catch (error) {
        // Storage may be unavailable in privacy modes.
      }
    };

    const getPreference = (key) => {
      try {
        return localStorage.getItem(key) === 'true';
      } catch (error) {
        return false;
      }
    };

    const setPrices = (visible) => {
      root.classList.toggle('staff-search--show-prices', visible);
      priceToggle.checked = visible;
      setPreference('staff-search-show-prices', visible);
    };

    const setBigPictures = (visible) => {
      root.classList.toggle('staff-search--big-pictures', visible);
      bigToggle.checked = visible;
      setPreference('staff-search-big-pictures', visible);

      for (const image of grid.querySelectorAll('img')) {
        image.sizes = visible
          ? '(min-width: 1200px) 1100px, 100vw'
          : '(min-width: 1200px) 25vw, (min-width: 750px) 33vw, 50vw';
      }
    };

    const addOptions = (select, values) => {
      const selected = select.value;
      const label = select.options[0].textContent;
      const uniqueValues = [...new Set(values.filter(Boolean))].sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
      );

      select.replaceChildren(new Option(label, ''));
      for (const value of uniqueValues) {
        select.add(new Option(value, value));
      }
      select.value = selected;
    };

    const populateFilters = () => {
      for (const select of form.querySelectorAll('[data-filter-select]')) {
        const field = select.dataset.field;
        const values = products.flatMap((product) => {
          const value = product[field];
          return Array.isArray(value) ? value : [value];
        });
        addOptions(select, values);
      }
    };

    const withinRange = (value, minimum, maximum) => {
      if (minimum === null && maximum === null) return true;
      if (value === null) return false;
      if (minimum !== null && value < minimum) return false;
      if (maximum !== null && value > maximum) return false;
      return true;
    };

    const anyWithinRange = (values, minimum, maximum) => {
      if (minimum === null && maximum === null) return true;
      return values.some((value) => withinRange(value, minimum, maximum));
    };

    const matchesValue = (productValue, selectedValue) => {
      if (!selectedValue) return true;
      const normalizedSelected = normalize(selectedValue);
      const values = Array.isArray(productValue) ? productValue : [productValue];
      return values.some((value) => normalize(value) === normalizedSelected);
    };

    const renderPagination = (totalPages) => {
      pagination.replaceChildren();
      if (totalPages <= 1) return;

      const previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'button-secondary';
      previous.textContent = 'Previous';
      previous.disabled = currentPage === 1;
      previous.addEventListener('click', () => {
        currentPage -= 1;
        renderResults(true);
      });

      const pageText = document.createElement('span');
      pageText.textContent = `Page ${currentPage} of ${totalPages}`;

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'button-secondary';
      next.textContent = 'Next';
      next.disabled = currentPage === totalPages;
      next.addEventListener('click', () => {
        currentPage += 1;
        renderResults(true);
      });

      pagination.append(previous, pageText, next);
    };

    const renderResults = (scroll = false) => {
      const totalPages = Math.max(1, Math.ceil(filteredProducts.length / pageSize));
      currentPage = Math.min(Math.max(currentPage, 1), totalPages);
      const start = (currentPage - 1) * pageSize;
      const visibleProducts = filteredProducts.slice(start, start + pageSize);

      grid.replaceChildren(...visibleProducts.map((product) => product.element));
      count.innerHTML = `<strong>${filteredProducts.length}</strong> ${
        filteredProducts.length === 1 ? 'product' : 'products'
      }`;

      if (visibleProducts.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'staff-search-results__empty';
        empty.innerHTML = '<h2>No matching products</h2><p>Try removing a filter or using a broader search term.</p>';
        grid.append(empty);
      }

      renderPagination(totalPages);
      setBigPictures(bigToggle.checked);

      if (scroll) {
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const applyFilters = (scroll = false) => {
      const data = new FormData(form);
      const keywords = normalize(data.get('keywords'));
      const priceMin = readNumber(data.get('priceMin'));
      const priceMax = readNumber(data.get('priceMax'));
      const caratMin = readNumber(data.get('caratMin'));
      const caratMax = readNumber(data.get('caratMax'));
      const centreDiamondMin = readNumber(data.get('centreDiamondMin'));
      const centreDiamondMax = readNumber(data.get('centreDiamondMax'));
      const gramMin = readNumber(data.get('gramMin'));
      const gramMax = readNumber(data.get('gramMax'));

      filteredProducts = products.filter(
        (product) =>
          (!keywords || product.searchText.includes(keywords)) &&
          matchesValue(product.productType, data.get('productType')) &&
          matchesValue(product.metal, data.get('metal')) &&
          matchesValue(product.tags, data.get('tags')) &&
          matchesValue(product.manufacturer, data.get('manufacturer')) &&
          matchesValue(product.stoneShape, data.get('stoneShape')) &&
          matchesValue(product.colour, data.get('colour')) &&
          matchesValue(product.clarity, data.get('clarity')) &&
          matchesValue(product.diamondOrigin, data.get('diamondOrigin')) &&
          withinRange(product.price, priceMin, priceMax) &&
          withinRange(product.caratWeight, caratMin, caratMax) &&
          withinRange(product.centreDiamondWeight, centreDiamondMin, centreDiamondMax) &&
          anyWithinRange(product.gramWeights, gramMin, gramMax)
      );

      const sortBy = data.get('sortBy');
      const sorters = {
        'price-ascending': (a, b) => a.price - b.price,
        'price-descending': (a, b) => b.price - a.price,
        'created-descending': (a, b) => b.published - a.published,
        'created-ascending': (a, b) => a.published - b.published,
        'title-ascending': (a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }),
        'title-descending': (a, b) => b.title.localeCompare(a.title, undefined, { numeric: true }),
        relevance: (a, b) => a.index - b.index,
      };
      filteredProducts.sort(sorters[sortBy] || sorters.relevance);

      currentPage = 1;
      renderResults(scroll);
    };

    const fetchPage = async (url) => {
      const response = await fetch(url, {
        signal: requestController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Catalogue request failed: ${response.status}`);
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      return documentFragment.querySelector('[data-staff-search-page]');
    };

    const loadCatalogue = async () => {
      if (requestController) requestController.abort();
      requestController = new AbortController();
      results.setAttribute('aria-busy', 'true');
      status.hidden = false;

      const baseUrl = new URL(`${window.Shopify.routes.root}search`, window.location.origin);
      baseUrl.searchParams.set('view', 'staff-fragment');
      baseUrl.searchParams.set('type', 'product');
      baseUrl.searchParams.set('q', '*');

      try {
        const firstPage = await fetchPage(baseUrl);
        if (!firstPage) throw new Error('Catalogue response was empty');

        const pageCount = Number(firstPage.dataset.pageCount || 1);
        const pages = [firstPage];
        const pageUrls = [];

        for (let page = 2; page <= pageCount; page += 1) {
          const pageUrl = new URL(baseUrl);
          pageUrl.searchParams.set('page', String(page));
          pageUrls.push(pageUrl);
        }

        for (let index = 0; index < pageUrls.length; index += 4) {
          const batch = pageUrls.slice(index, index + 4);
          pages.push(...(await Promise.all(batch.map((url) => fetchPage(url)))));
          status.textContent = `Loading catalogue… ${Math.min(index + 5, pageCount)} of ${pageCount}`;
        }

        const elements = pages.flatMap((page) =>
          page ? [...page.querySelectorAll('[data-staff-product]')] : []
        );
        products = elements.map(parseProduct);
        populateFilters();
        applyFilters();
        results.hidden = false;
        status.hidden = true;
      } catch (error) {
        if (error.name !== 'AbortError') {
          status.textContent = 'The catalogue could not be loaded. Please refresh and try again.';
        }
      } finally {
        results.removeAttribute('aria-busy');
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      applyFilters(true);
    });

    form.addEventListener('reset', () => {
      window.setTimeout(() => applyFilters(), 0);
    });

    priceToggle.addEventListener('change', () => setPrices(priceToggle.checked));
    bigToggle.addEventListener('change', () => setBigPictures(bigToggle.checked));

    setPrices(getPreference('staff-search-show-prices'));
    setBigPictures(getPreference('staff-search-big-pictures'));
    loadCatalogue();
  })();

  } catch(e) { console.error(e); }
})();
})();
